// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_2qkTcn93tvu2k_96oY0lDT","Input":"_1og3zUB53k4oZkS9u7jUeg","Suggestions":"_1EWTH75fFeTlW-F-x3SnsZ","Selected":"_2uABCG6OANKpmV9sNwuVqf","SelectedTag":"_3QYEsBh5unE-jYOf9ISXly"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/StatisticTag/styles.module.css
// module id = 577
// module chunks = 0